module.exports = __webpack_public_path__ + "img/team_logo.ccc41633.png";